import { trackEvent } from '@grnhse/datacoral_tracker';

window.__trackEvent = trackEvent;
